import { combineReducers } from 'redux';
import templateReducer from 'components/Template/Template.reducer';
import previewReducer from 'components/Preview/Preview.reducer';
import reportSettingsReducer from 'components/ReportSettings/ReportSettings.reducer';
import dashboardReducer from 'components/Dashboard/Dashboard.reducer';
import tourReducer from 'components/UserTour/Tour.reducer';

const rootReducer = combineReducers({
	templateReducer,
	previewReducer,
	reportSettingsReducer,
	dashboardReducer,
	tourReducer
});

export default rootReducer;
